export const home = "/home"
export const login = "/login"
export const register = '/register'
export const resetpwd = '/resetPassword'
export const forgotpwd = '/forgot-password'
export const graceMarksManagement = "/grace-marks-mgmt"
export const timeTable = "/time-table"
export const dashboard = "/dashboard"
export const learnerDashboard = "/learnerDashboard"
export const productDashboard = '/productDashboard'
export const addNewProduct = '/addNewProduct'
export const corporateClientsDashboard = '/corporateClientDashboard'
export const businessPartnerDashboard = '/businessPartnerDashboard'
export const facilitatorDashboard = '/facilitatorDashboard'
export const facilitatorCertification = '/facilitatorCertification'
export const facilitatorProfile = '/facilitatorProfile/:facilitatorId'
export const businessPartner = '/busniessPartner'
export const facilitator = '/facilitator'
export const tttSchedule = '/tttSchedule'
export const agentDashboard = '/agent-dashboard'
export const agentPerformanceDashboard = '/agent-performance-dashboard'
export const countryManagerDashboard = '/country-manager-dashboard'
export const lmBuilder = '/lm-builder'
export const lmBuilderV2 = '/lm-builder-v2'
export const doubtsDashboard = '/doubts-dashboard'

export const rubricEvaluation = '/rubric-evaluation'
export const aiGradingStudio = '/ai-grading-studio'
export const studyResources = '/study-resources'
export const myResources = '/my-resources'
export const launchAttendance = '/launchAttendance/activitySlotTemplate/:activitySlotId'

// Student Affairs - Hostel Management
export const habCommittee = '/student-affairs/committee/hab-committee'
export const staffAssignments = '/student-affairs/hostel-staff/staff-assignments'
export const messFacilities = '/student-affairs/mess-facilities'

// Research Management - Masters & PhD
export const researchManagement = '/research-management'
export const researchStudents = '/research-management/students'
export const researchSupervisors = '/research-management/supervisors'
export const researchThesis = '/research-management/thesis'
export const researchMilestones = '/research-management/milestones'
export const researchCommittees = '/research-management/committees'
export const researchSeminars = '/research-management/seminars'

// Schedules Management
export const schedules = '/schedules'
export const scheduleDetail = '/schedules/:id'

// Schedules Templates Management
export const schedulesTemplates = '/schedules-templates'
export const schedulesTemplatesNew = '/schedules-templates/new'
export const schedulesTemplatesDetail = '/schedules-templates/:id'

// AI Workspace
export const aiWorkspaceConfig = '/ai-workspace-config'
export const aiWorkspace = '/ai-workspace'
export const aiSubscriptions = '/ai-subscriptions'

// Question Bank
export const questionBank = '/question-bank'

// Quick Quiz Maker
export const quickQuizMaker = '/quick-quiz-maker'

// Instructor Dashboard
export const myTeachingPlan = '/my-teaching-plan'
export const instructorBatches = '/instructor-batches'

// Grid Report
export const gridReport = '/grid-report'

// Data Ingestion
export const dataIngestion = '/student-data-ingestion'
export const enquiryIngestion = '/enquiry-data-ingestion'
export const studentPhotoUpload = '/student-photo-upload'
export const uploadedDocsLog = '/uploaded-docs-log'
export const personalizedDocuments = '/personalized-documents'

// SCORM course library
export const scormCourses = '/scorm-courses'

// Compliance dashboard
export const compliance = '/compliance'

// Student Search
export const studentSearch = '/student-search'

// Enrollment View
export const enrollmentView = '/enrollment/view/:enrollmentId'

// Payment Console
export const paymentConsole = '/payment-console'

// Governance Console — multi-provider marketplace governance (policy library, certification queue, audit)
export const governanceConsole = '/governance-console'

// Provider Studio — provider-self-service surface (catalog, revenue, adoptions). Scoped by :partnerId.
export const providerStudio = '/provider-studio'
export const providerStudioWithId = '/provider-studio/:partnerId'

// Agency Console — buyer-self-service surface (catalog browse, adoptions, credential coverage). Scoped by :schoolId.
export const agencyConsole = '/agency-console'
export const agencyConsoleWithId = '/agency-console/:schoolId'

// Webform (staff enquiry create/edit)
export const webformCreate = '/webform/:formId'
export const webformEdit = '/webform/:formId/enquiry/:enquiryId'

// Voila Board
export const voilaBoard = '/voila-board'

// Webform Admin (manage form definitions)
export const webformAdmin = '/webform-admin'
export const webformAdminNew = '/webform-admin/new'
export const webformAdminEdit = '/webform-admin/:id'

// Assignments
export const assignments = '/assignments'
export const assignmentSubmissions = '/assignments/:id/submissions'

// Discussion Board
export const discussionBoard = '/discussion-board'
export const discussionBoardDetail = '/discussion-board/:boardId'
export const discussionBoardTopic = '/discussion-board/:boardId/topic/:topicId'

// Provider Console (marketplace)
